import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPatchAdminConsumptionsDetail_consumptionId = z.any()
export type TagsPatchAdminConsumptionsDetail_consumptionId = z.infer<typeof tagsPatchAdminConsumptionsDetail_consumptionId>

export const paramsPatchAdminConsumptionsDetail_consumptionId = z.object({ "consumptionId": z.string() })
export type ParamsPatchAdminConsumptionsDetail_consumptionId = z.infer<typeof paramsPatchAdminConsumptionsDetail_consumptionId>

export const bodyPatchAdminConsumptionsDetail_consumptionId = z.object({ "number": z.string().optional(), "consumptionNT": z.union([z.string(), z.number()]).optional(), "consumptionVT": z.union([z.string(), z.number()]).optional(), "consumptionGeneric": z.union([z.string(), z.number()]).optional() })
export type BodyPatchAdminConsumptionsDetail_consumptionId = z.infer<typeof bodyPatchAdminConsumptionsDetail_consumptionId>

export const responsePatchAdminConsumptionsDetail_consumptionId = z.object({ "payload": z.object({ "id": z.string().max(191), "collectionPointId": z.string().max(255), "submeterId": z.union([z.string().max(255), z.null()]), "consumptionNT": z.string(), "consumptionVT": z.string(), "number": z.string().max(255), "fileProcessId": z.union([z.string().max(255), z.null()]), "consumptionGeneric": z.string(), "meterChange": z.union([z.union([z.union([z.string(), z.number(), z.boolean(), z.null()]), z.array(z.any()), z.record(z.any()).superRefine((value, ctx) => {
for (const key in value) {
if (key.match(new RegExp("^(.*)$"))) {
const result = z.any().safeParse(value[key])
if (!result.success) {
ctx.addIssue({
          path: [...ctx.path, key],
          code: 'custom',
          message: `Invalid input: Key matching regex /${key}/ must match schema`,
          params: {
            issues: result.error.issues
          }
        })
}
}
}
})]), z.null()]), "meterChangeInferredFields": z.union([z.union([z.union([z.string(), z.number(), z.boolean(), z.null()]), z.array(z.any()), z.record(z.any()).superRefine((value, ctx) => {
for (const key in value) {
if (key.match(new RegExp("^(.*)$"))) {
const result = z.any().safeParse(value[key])
if (!result.success) {
ctx.addIssue({
          path: [...ctx.path, key],
          code: 'custom',
          message: `Invalid input: Key matching regex /${key}/ must match schema`,
          params: {
            issues: result.error.issues
          }
        })
}
}
}
})]), z.null()]), "invoiceId": z.union([z.string().max(255), z.null()]), "createdBy": z.union([z.string().max(255), z.null()]), "createdAt": z.string(), "updatedAt": z.string(), "deletedAt": z.union([z.string(), z.null()]) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePatchAdminConsumptionsDetail_consumptionId = z.infer<typeof responsePatchAdminConsumptionsDetail_consumptionId>

interface IPatchAdminConsumptionsDetail_consumptionId extends BaseMethodType {
  tags: TagsPatchAdminConsumptionsDetail_consumptionId,
  params: ParamsPatchAdminConsumptionsDetail_consumptionId,
  body: BodyPatchAdminConsumptionsDetail_consumptionId,
  response: ResponsePatchAdminConsumptionsDetail_consumptionId
}
export const tagsDeleteAdminConsumptionsDetail_consumptionId = z.any()
export type TagsDeleteAdminConsumptionsDetail_consumptionId = z.infer<typeof tagsDeleteAdminConsumptionsDetail_consumptionId>

export const paramsDeleteAdminConsumptionsDetail_consumptionId = z.object({ "consumptionId": z.string() })
export type ParamsDeleteAdminConsumptionsDetail_consumptionId = z.infer<typeof paramsDeleteAdminConsumptionsDetail_consumptionId>

export const responseDeleteAdminConsumptionsDetail_consumptionId = z.any()
export type ResponseDeleteAdminConsumptionsDetail_consumptionId = z.infer<typeof responseDeleteAdminConsumptionsDetail_consumptionId>

interface IDeleteAdminConsumptionsDetail_consumptionId extends BaseMethodType {
  tags: TagsDeleteAdminConsumptionsDetail_consumptionId,
  params: ParamsDeleteAdminConsumptionsDetail_consumptionId,
  response: ResponseDeleteAdminConsumptionsDetail_consumptionId
}
export const URL = '/admin/consumptions/detail/:consumptionId'
export const validation = {
  patch: {
    tags: tagsPatchAdminConsumptionsDetail_consumptionId,
    params: paramsPatchAdminConsumptionsDetail_consumptionId,
    body: bodyPatchAdminConsumptionsDetail_consumptionId,
    response: responsePatchAdminConsumptionsDetail_consumptionId
  },
  delete: {
    tags: tagsDeleteAdminConsumptionsDetail_consumptionId,
    params: paramsDeleteAdminConsumptionsDetail_consumptionId,
    response: responseDeleteAdminConsumptionsDetail_consumptionId
  }
}
export interface AdminConsumptionsDetail_consumptionId extends BaseRouteType {
  patch: IPatchAdminConsumptionsDetail_consumptionId,
  delete: IDeleteAdminConsumptionsDetail_consumptionId
}